import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=3ae905fa&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae905fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae905fa')) {
      api.createRecord('3ae905fa', component.options)
    } else {
      api.reload('3ae905fa', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=3ae905fa&scoped=true&", function () {
      api.rerender('3ae905fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iCve5ibT4ycf/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports